import type { AxiosResponse } from "axios";
import { createMutation } from "react-query-kit";

import type { ID } from "@constants";
import type { AxiosError, IApiResponse, IAxiosFn } from "@/api";
import { axiosClient } from "@/api";

type IResponse = AxiosResponse<IApiResponse<unknown>>;
interface IVariables {
  appointmentId: ID;
}

export const endMeet: IAxiosFn<IVariables, IResponse> = async (
  params,
  signal,
) => {
  return axiosClient.post(`video-visit/${params?.appointmentId}/end-meet`, {
    signal,
  });
};

export const useEndMeet = createMutation<IResponse, IVariables, AxiosError>({
  mutationFn: (data: IVariables) => endMeet(data),
});
